function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ICON_GREY_MENU_svg__cls-1",
  d: "M50 0v6.86H0V0zm0 21v6.86H0V21zm0 21v6.86H0V42z"
});

function SvgIconGreyMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 50 48.86"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA0OC44NiI+PGRlZnM+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTUwLDBWNi44NkgwVjBabTAsMjF2Ni44NkgwVjIxWm0wLDIxdjYuODZIMFY0MloiLz48L3N2Zz4=";
export { SvgIconGreyMenu as ReactComponent };